/* ============================================================================
   App root.
   Eagerly imports EVERY feature module's *.routes.tsx so they self-register
   with the route/nav registry before the shell renders. Adding a module is
   drop-in: create /modules/<name>/<name>.routes.tsx and it appears — no edits
   to this file or any shared file.
   ============================================================================ */

import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import AppShell from './app/AppShell';

// Self-registration: eager side-effect imports of every module route + tab file.
// Evaluated for their side effects (each module calls registerRoute /
// registerRequestTab at import time) — no binding is kept.
import.meta.glob('./modules/**/*.routes.tsx', { eager: true });
import.meta.glob('./modules/**/*.tab.tsx', { eager: true });

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </AuthProvider>
  );
}
